"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _loglevel = _interopRequireDefault(require("loglevel"));

var _api = _interopRequireDefault(require("../../api/services/api"));

var _config = _interopRequireDefault(require("../../config"));

/* eslint-disable prefer-promise-reject-errors */
var MODULE_NAME = 'sdk/device/services/device';

var logger = _loglevel.default.getLogger(MODULE_NAME); // const MISSING_PARAMS = 'MISSING_PARAMS';

/**
 * @param device
 * @param domain
 * @param userId
 * @param callProcess
 * @returns {Promise<never>|Promise<boolean>}
 */


var create = function create(_ref) {
  var device = _ref.device,
      domain = _ref.domain,
      userId = _ref.userId,
      _ref$callProcess = _ref.callProcess,
      callProcess = _ref$callProcess === void 0 ? '' : _ref$callProcess;
  logger.info("".concat(MODULE_NAME, " - create called"), {
    device: device,
    domain: domain,
    userId: userId
  }); // todo regex for device string

  if (!device || !domain || !userId) {
    console.error("".concat(MODULE_NAME, " - create device missing required params"));
    return Promise.reject();
  }

  if (!_config.default.hasValidConfig()) {
    console.error('nsSDK not configured');
    return Promise.reject(false);
  }

  var params = {
    object: 'device',
    action: 'create',
    device: device,
    domain: domain,
    user: userId || _config.default.getConfiguration().userId,
    call_processing_rule: callProcess
  };
  return _api.default.post(params, {}).then(function () {
    return true;
  }).catch(function () {
    return false;
  });
};
/**
 *
 * @param device
 * @param domain
 * @param userId
 * @param callProcess
 * @returns {Promise}
 */


var update = function update(_ref2) {
  var device = _ref2.device,
      domain = _ref2.domain,
      userId = _ref2.userId,
      _ref2$callProcess = _ref2.callProcess,
      callProcess = _ref2$callProcess === void 0 ? '' : _ref2$callProcess;
  logger.info("".concat(MODULE_NAME, " - update called"), {
    device: device,
    domain: domain,
    userId: userId,
    callProcess: callProcess
  });
  return new Promise(function (resolve, reject) {
    // todo regex for device string
    if (!device || !domain || !userId) {
      console.error("".concat(MODULE_NAME, " - update device missing required params"));
      reject(false);
    }

    if (!_config.default.hasValidConfig()) {
      console.error('nsSDK not configured');
      reject(false);
    }

    var params = {
      object: 'device',
      action: 'update',
      user: userId || _config.default.getConfiguration().userId,
      domain: domain
    };

    if (device) {
      params.device = device;
    }

    if (callProcess) {
      params.call_processing_rule = callProcess;
    }

    _api.default.post(params, {}).then(function () {
      return true;
    }).catch(function () {
      return false;
    });
  });
};
/**
 *
 * @param {string} device
 * @param {string} domain
 * @param {string|int} userId
 * @param {string} callProcess
 * @param {boolean} createDevice
 * @return {Promise}
 */


var get = function get(_ref3) {
  var device = _ref3.device,
      domain = _ref3.domain,
      userId = _ref3.userId,
      _ref3$callProcess = _ref3.callProcess,
      callProcess = _ref3$callProcess === void 0 ? '' : _ref3$callProcess,
      _ref3$createDevice = _ref3.createDevice,
      createDevice = _ref3$createDevice === void 0 ? false : _ref3$createDevice;
  logger.info("".concat(MODULE_NAME, " - get called"), {
    device: device,
    domain: domain,
    userId: userId,
    callProcess: callProcess,
    createDevice: createDevice
  });
  return new Promise(function (resolve, reject) {
    // todo regex for device string
    if (!device || !domain || !userId) {
      console.error("".concat(MODULE_NAME, " - get device missing required params"));
      reject(false);
    }

    if (!_config.default.hasValidConfig()) {
      console.error('nsSDK not configured');
      reject(false);
    }

    _api.default.get({
      object: 'device',
      action: 'read',
      device: device,
      user: userId || _config.default.getConfiguration().userId,
      domain: domain,
      format: 'json',
      noNDP: true
    }).then(function (res) {
      if (res && res.length) {
        // update previous devices that should have a callProcess of 'PresenceIgnore'
        if (res[0].call_processing_rule !== callProcess && !(res[0].call_processing_rule || '').includes('Record') && !(res[0].call_processing_rule || '').includes('Push')) {
          update({
            device: device,
            domain: domain,
            userId: userId,
            callProcess: callProcess
          }).then(function (result) {
            // eslint-disable-next-line no-param-reassign
            result[0].call_processing_rule = callProcess;
            resolve(result[0]);
          });
        } else if ((res[0].call_processing_rule || '').includes('Record') || (res[0].call_processing_rule || '').includes('Push')) {
          res[0].call_processing_rule = callProcess;
          resolve(res[0]);
        } else {
          resolve(res[0]);
        }
      } else if (createDevice) {
        create({
          device: device,
          domain: domain,
          userId: userId,
          callProcess: callProcess
        }).then(function (result) {
          if (result) {
            var interval = setInterval(function () {
              _api.default.get({
                object: 'device',
                action: 'read',
                device: device,
                user: userId || _config.default.getConfiguration().userId,
                domain: domain,
                format: 'json',
                noNDP: true
              }).then(function (result2) {
                if (result2) {
                  clearInterval(interval);
                  resolve(result2[0]);
                }
              });
            }, 500);
          } else {
            reject(false);
          }
        }).catch(function () {
          reject(false);
        });
      } else {
        reject(false);
      }
    }).catch(function (err) {
      reject(err);
    });
  });
};

var _default = {
  create: create,
  get: get,
  update: update
};
exports.default = _default;
module.exports = exports.default;